import { reactive, computed, onMounted, watch } from 'vue';
import { useRouter } from 'vue-router'
import { useStore } from 'vuex';
import { POPUP, BTN, UNIT, CONNECTION, USERMODE } from '@/enum/enum';
import CollapseMultiSelect from '@/components/ui/collapsemutiselect2/index.vue';
import Button from '@/components/ui/button/index.vue';
import Radio from '@/components/ui/radio/index.vue';
import Select from '@/components/ui/select/index.vue';
import Slidebar from '@/components/ui/slidebar/index.vue';
import Cardimg from '@/components/ui/cardimg/index.vue';
import Input from '@/components/ui/input/index.vue';
import { apiGetDevice, apiGetCalibration, apiGetGroupModel, apiGroupDeviceList, apiGroup } from '@/api/api';
import { useI18n } from 'vue-i18n';
export default {
  components: {
    CollapseMultiSelect,
    Button,
    Radio,
    Select,
    Slidebar,
    Cardimg,
    Input,
  },
  props: {
  },
  setup(props, { emit }) {//emit 傳到複層_emit('update:{function}', val)
    const { icon, isCheck } = props;
    const { t } = useI18n();

    //data
    let state = reactive({
      scaleType: 'Devices',
      nextData: [],
      nextTitle: '',
      tempData: [],  //選擇modal list 的暫存陣列
      dataToMulti: [],
      popup_table_title: [
        {
          title: "Serial Number",
          key: "serialNumber",
          sort: true,
        },
        {
          title: "Model",
          key: "model",
        },
        {
          title: "PC Name",
          key: "pcName",
        },
        {
          title: "Group",
          key: "group",
        },
        {
          title: "Connection Status",
          key: "connectionStatus",
          color: true,
        },
      ],
      popup_table_date: [],
      popup_table_data_group: [], //新增group的 list
      selectedVal: USERMODE[1],
      target: {
        text: 'Target',
        val: 'default',
        isI18n: undefined,
      },
      target_op: [],
      target_private: {
        text: 'Target',
        val: 'default',
      },
      gamutType: 'standard', // 'standard' or 'customized'
      gamut: {
        text: 'sRGB',
        val: 0,
      },
      color_standard: {
        text: 'D50',
        val: 0,
      },
      gamut_op: [
        { text: 'sRGB / BT.709', val: 0 },
        { text: 'Adobe RGB', val: 1 },
        // { text: 'BT.709', val: 2 },
        { text: 'DCI-P3', val: 3 },
        { text: 'BT.2020', val: 4 },
        { text: 'EBU', val: 5 },
        { text: 'SMPTE-C', val: 6 },
        { text: 'Custom', val: 7 }
      ],
      customGamut: {
        red: { x: '0.6400', y: '0.3300' },
        green: { x: '0.3000', y: '0.6000' },
        blue: { x: '0.1500', y: '0.0600' }
      },
      color_standard_op: [
        { text: 'D50', val: 0 },
        { text: 'D55', val: 1 },
        { text: 'D65', val: 2 },
        { text: 'DCI-P3', val: 3 }
      ],
      gamut_disable: true,
      brightness_max_fix_right: 25,
      brightness_max_data: [300, 400, 500, 600, 700, 800, 900],
      brightness_max: 300,
      brightness_max_start: 300,
      brightness_max_default: 0,
      brightness_max_max: true,
      brightness_max_min: false,
      brightness_max_step: 10,
      brightness_min_fix_right: 25,
      brightness_min_data: [300, 400, 500, 600, 700, 800, 900],
      brightness_min: 300,
      brightness_min_start: 300,
      brightness_min_default: 0,
      brightness_min_dot: true,
      brightness_min_max: false,
      brightness_min_min: true,
      temperature_data: [40, 50, 60, 70, 80, 90],
      temperature: 40,
      temperature_max: false,
      temperature_min: false,
      temperature_lock: false,
      temperature_start: 40,
      temperature_default: 0,
      gamma_fix_right: 0,
      gamma_data: [],
      gamma_data_default: [1.8, 1.9, 2.0, 2.1, 2.2, 2.3, 2.4, 2.5, 2.6, 2.8],
      gamma: 0,
      gamma_start: 0.8,
      gamma_default: 0,
      gamma_dot: true,
      EOTF: {
        text: 'EOTF',
        val: 'default',
      },
      EOTF_op: [],
      EOTF_op_default: [],
      EOTF_private: {
        text: 'EOTF',
        val: 'default',
      },
      card: [],
      APICalibrationData: {},
      bright_max: 0,
      bright_min: 0,
      model: "",
      disable_all: true,
      group_op: [],
      device_op: [],
      isslide: false,
      showGamutSelect: false,//是否秀出color gamut選單
      dicomSelect_op: [], //color gamut選單
      dicomGamut: { text: '', val: 0 },//color gamut選定
      isTargetSwitching: false, //標記是否正在切換 target，避免觸發其他參數的 change 函數
      whitePointSelect: 'colorTemperature',
      whitePointDisable: 2,
      coordinate: {
        x: undefined,
        y: undefined
      },
      coordinateEnum: {
        XMax: '0.47',
        XMin: '0.27',
        XDefault: '0.27',
        YMax: '0.45',
        YMin: '0.27',
        YDefault: '0.27',
      },
    })

    const iconSrc = computed(() => {
      if (icon === '') return '';
      return icon.indexOf('http') > -1 ? icon : require(`@/assets/images/${icon}`)
    })

    // 確保 whitePointSelect 始終有有效值
    const safeWhitePointSelect = computed({
      get() {
        const validValues = ['standard', 'colorTemperature', 'coordinate'];
        return validValues.includes(state.whitePointSelect) ? state.whitePointSelect : 'colorTemperature';
      },
      set(value) {
        if (value && ['standard', 'colorTemperature', 'coordinate'].includes(value)) {
          state.whitePointSelect = value;
        }
      }
    })


    const popup_table_title_group = computed(() => { //選group並新增多個group的table
      return [
        {
          title: t('__g3p_m8t.__nameThisGroup'),
          key: "name",
          sort: true,
        },
        {
          title: t('__common.__model'),
          key: "model",
        },
        {
          title: t('__g3p_m8t.__deviceAmount'),
          key: "device_count",
          sort: true,
        },
        {
          title: t('__d7d_n17r.__connectionStatus') + ' (' + t('__g3p_m8t.__online') + ' /' + t('__g3p_m8t.__offline') + ')',
          key: "connection",
        },
      ]
    })

    const popup_table_title = computed(() => {
      return [
        {
          title: t('__g3p_m8t.__serialNumber'),
          key: "serialNumber",
          sort: true,
        },
        {
          title: t('__common.__model'),
          key: "model",
        },
        {
          title: t('__d7d_n17r.__pcName'),
          key: "pcName",
        },
        {
          title: t('__common.__group'),
          key: "group",
        },
        {
          title: t('__d7d_n17r.__connectionStatus'),
          key: "connectionStatus",
          color: true,
          colorEnum:
          {
            0: CONNECTION[0],
            1: CONNECTION[1],
            2: CONNECTION[2],
          },
          isI18n:
          {
            0: '__g3p_m8t.__offline',
            1: '__g3p_m8t.__online',
            2: '__g3p_m8t.__waiting',
          },
        },
      ]
    })




    // methods
    const CheckAllSlide = () => {
      var _return = true;
      if (state.brightness_max_data.length > 0 && state.brightness_max_start != state.brightness_max) {
        _return = false;
      }
      if (state.brightness_min_data.length > 0 && state.brightness_min_start != state.brightness_min) {
        _return = false;
      }
      if (state.temperature_data.length > 0 && state.temperature_start * 100 != state.temperature) {
        _return = false;
      }
      if (state.gamma_data.length > 0 && state.gamma_start != state.gamma) {
        _return = false;
      }
      if (state.target_op.length > 0 && _return) {
        var _target = state.target_op[state.target_op.map(x => x.val).indexOf(state.target.val)];
        state.target.isI18n = _target.isI18n
        state.target.text = _target.text;
      }

    }
    const chooseItem = (e) => {
      state.tempData.push(e)
    }
    const brightness_max_change = (e) => {
      state.brightness_max = e;
      if (state.isTargetSwitching) {
        console.log('brightness_max_change: isTargetSwitching, skip');
        return; // 如果正在切換 target，不執行後續邏輯
      }
      var _isSameTarget = true;
      var _targetNumber = state.target_op.map(x => x.val).indexOf(state.target.val);
      if (_targetNumber != -1) {
        if (state.target_op[_targetNumber].eotf != state.EOTF.text) {
          _isSameTarget = false
        }
      }
      // 如果已經是 Customized 模式，不需要再檢查
      if (state.target.text === "Customized") {
        console.log('ℹbrightness_max_change: 已經是 Customized 模式，跳過檢查');
        return;
      }

      if (e != state.brightness_max_default && e != 1000000 || !_isSameTarget) {
        console.log('brightness_max_change: 觸發 Customized');
        state.target = {
          text: "Customized",
          val: state.target.val,
          isI18n: '__c3r_c9n.__customized',
        }
      } else {
        CheckAllSlide();
      }
    }
    const brightness_min_change = (e) => {
      state.brightness_min = e;
      if (state.isTargetSwitching) {
        console.log('brightness_min_change: isTargetSwitching, skip');
        return; // 如果正在切換 target，不執行後續邏輯
      }
      var _isSameTarget = true;
      var _targetNumber = state.target_op.map(x => x.val).indexOf(state.target.val);
      if (_targetNumber != -1) {
        if (state.target_op[_targetNumber].eotf != state.EOTF.text) {
          _isSameTarget = false
        }
      }

      // 如果已經是 Customized 模式，不需要再檢查
      if (state.target.text === "Customized") {
        console.log('brightness_min_change: 已經是 Customized 模式，跳過檢查');
        return;
      }

      if (e != state.brightness_min_default || !_isSameTarget) {
        console.log('brightness_min_change: 觸發 Customized');
        state.target = {
          text: "Customized",
          val: state.target.val,
          isI18n: '__c3r_c9n.__customized',
        }
      } else {
        CheckAllSlide();
      }
    }
    const temperature_change = (e) => {
      state.temperature = e;
      if (state.isTargetSwitching) {
        console.log('temperature_change: isTargetSwitching, skip');
        return; // 如果正在切換 target，不執行後續邏輯
      }
      var _isSameTarget = true;
      var _targetNumber = state.target_op.map(x => x.val).indexOf(state.target.val);
      if (_targetNumber != -1) {
        if (state.target_op[_targetNumber].eotf != state.EOTF.text) {
          _isSameTarget = false
        }
      }
      // 如果已經是 Customized 模式，不需要再檢查
      if (state.target.text === "Customized") {
        console.log('temperature_change: 已經是 Customized 模式，跳過檢查');
        return;
      }

      if (e != state.temperature_default * 100 || !_isSameTarget) {
        console.log('temperature_change: 觸發 Customized');
        state.target = {
          text: "Customized",
          val: state.target.val,
          isI18n: '__c3r_c9n.__customized',
        }
      } else {
        CheckAllSlide();
      }
    }
    const gamma_change = (e) => {
      state.gamma = e;
      if (state.isTargetSwitching) {
        console.log('gamma_change: isTargetSwitching, skip');
        return; // 如果正在切換 target，不執行後續邏輯
      }
      var _isSameTarget = true;
      var _targetNumber = state.target_op.map(x => x.val).indexOf(state.target.val);
      if (_targetNumber != -1) {
        if (state.target_op[_targetNumber].eotf != state.EOTF.text) {
          _isSameTarget = false
        }
      }

      // 如果已經是 Customized 模式，不需要再檢查
      if (state.target.text === "Customized") {
        console.log('gamma_change: 已經是 Customized 模式，跳過檢查');
        return;
      }

      if (e != state.gamma_default || !_isSameTarget) {
        console.log('gamma_change: 觸發 Customized');
        state.target = {
          text: "Customized",
          val: state.target.val,
          isI18n: '__c3r_c9n.__customized',
        }
      } else {
        CheckAllSlide();
      }
    }
    const coordinate_change = (e) => {
      if (state.isTargetSwitching) {
        console.log('coordinate_change: isTargetSwitching, skip');
        return; // 如果正在切換 target，不執行後續邏輯
      }
      let isSameTarget = true;
      let _targetNumber = state.target_op.map(x => x.val).indexOf(state.target.val);
      if (_targetNumber != -1) {
        if (state.target_op[_targetNumber].eotf != state.EOTF.text) {
          isSameTarget = false
        }
      }

      // 如果已經是 Customized 模式，不需要再檢查
      if (state.target.text === "Customized") {
        console.log('coordinate_change: 已經是 Customized 模式，跳過檢查');
        return;
      }

      // state.coordinate['x'] = coordinate['x']['default'].toString()
      //   state.coordinate['y'] = coordinate['y']['default'].toString()
      if (e['x'] != state.coordinateEnum['XDefault'] || e['y'] != state.coordinateEnum['YDefault'] || !isSameTarget) {
        console.log('coordinate_change: 觸發 Customized');
        state.target = {
          text: "Customized",
          val: state.target.val,
          isI18n: '__c3r_c9n.__customized',
        }
      }
      else {
        CheckAllSlide();
      }
    }
    const setLineBar = () => {
      var _mode = "";//DICOM,HDR,SDR
      //#region 判斷_mode
      var _key;
      if (_mode == '' && state.EOTF.text == "DICOM") {
        _mode = "DICOM"
      }
      if (_mode == '' && state.APICalibrationData['eotf']['HDR']) {
        _key = Object.keys(state.APICalibrationData['eotf']['HDR'])
        for (var hdr = 0; hdr < _key.length; hdr++) {
          if (state.EOTF.text == _key[hdr]) {
            _mode = "HDR"
          }
        }
      }
      if (_mode == '' && state.APICalibrationData['eotf']['SDR']) {
        _key = Object.keys(state.APICalibrationData['eotf']['SDR'])
        for (var sdr = 0; sdr < _key.length; sdr++) {
          if (state.EOTF.text == _key[sdr]) {
            _mode = "SDR"
          }
        }
      }
      //#endregion

      if (_mode == "DICOM") {
        state.brightness_max_data = [];
        state.brightness_min_data = [];
        state.temperature_data = [];
        state.gamma_data = [];
        var _difference_max = (state.APICalibrationData['brightness']['DICOM']['brightness']['range_max'] - state.APICalibrationData['brightness']['DICOM']['brightness']['range_min']) / 6
        for (var a = 0; a <= 6; a++) {
          let minDICOMData = state.APICalibrationData['brightness']['DICOM']['brightness']['range_min'];
          let maxDICOMData = state.APICalibrationData['brightness']['DICOM']['brightness']['range_max'];
          var _math = 100;
          if (minDICOMData / 100 < 1 || maxDICOMData - minDICOMData < 100) {
            _math = 10
          }

          var _max = Math.round((state.APICalibrationData['brightness']['DICOM']['brightness']['range_min'] + _difference_max * a) / _math) * _math;
          if (_max > maxDICOMData) _max = maxDICOMData;
          state.brightness_max_data.push(_max)
        }
        state.brightness_min_data = state.APICalibrationData['brightness']['DICOM']['brightness_min']['range_values']
        state.brightness_max_data = state.brightness_max_data.filter(function (ele, pos) {
          return state.brightness_max_data.indexOf(ele) == pos;
        })
        // 確保 brightness_max_data 從左到右、小到大排序
        state.brightness_max_data.sort((a, b) => a - b);
        state.brightness_max_max = state.APICalibrationData['brightness']['DICOM']['brightness']['max']
        state.brightness_max_min = state.APICalibrationData['brightness']['DICOM']['brightness']['min']
        state.brightness_min_max = state.APICalibrationData['brightness']['DICOM']['brightness_min']['max']
        state.brightness_min_min = state.APICalibrationData['brightness']['DICOM']['brightness_min']['min']
        state.brightness_max_step = state.APICalibrationData['brightness']['DICOM']['brightness']['step']
        state.bright_max = state.APICalibrationData['brightness_max']
        state.bright_min = state.APICalibrationData['brightness_min']
        if (state.brightness_max_start == 0) {
          state.brightness_max_start = state.brightness_max_data[0];
        } else if (state.brightness_max_start > state.brightness_max_data[state.brightness_max_data.length - 1] && !state.brightness_max_max) {
          state.brightness_max_start = state.brightness_max_data[state.brightness_max_data.length - 1];
        } else if (state.brightness_max_start > state.brightness_max_data[state.brightness_max_data.length - 1] && state.brightness_max_max && state.brightness_max_start != state.bright_max) {
          state.brightness_max_start = state.brightness_max_data[state.brightness_max_data.length - 1];
        }
        if (state.brightness_min_start == -1) {
          state.brightness_min_start = state.brightness_min_data[0];
        } else if (state.brightness_min_start != state.bright_min && state.brightness_min_min && state.brightness_min_start < state.brightness_min_data[0]) {
          state.brightness_min_start = state.brightness_min_data[0];
        } else if (!state.brightness_min_min && state.brightness_min_start < state.brightness_min_data[0]) {
          state.brightness_min_start = state.brightness_min_data[0];
        }
        // if (state.APICalibrationData['color_temperature']['SDR']['fix']) {
        //   state.temperature_lock = true;
        //   state.temperature_start = state.APICalibrationData['color_temperature']['SDR']['fix'] / 100
        //   _difference_max = (10000 - 4000) / 6
        //   for (a = 0; a <= 6; a++) {
        //     _max = Math.round((4000 + _difference_max * a) / 100) * 100;
        //     state.temperature_data.push(_max / 100)
        //   }
        //   state.temperature_data = state.temperature_data.filter(function (ele, pos) {
        //     return state.temperature_data.indexOf(ele) == pos;
        //   })
        // } else 
        if (state.APICalibrationData['color_temperature']['step']) {
          state.temperature_lock = false;
          _difference_max = (state.APICalibrationData['color_temperature']['range_max'] - state.APICalibrationData['color_temperature']['range_min']) / 6
          for (a = 0; a <= 6; a++) {
            _math = 100;
            if (state.APICalibrationData['color_temperature']['range_min'] / 100 < 1) {
              _math = 10
            }
            _max = Math.round((state.APICalibrationData['color_temperature']['range_min'] + _difference_max * a) / _math) * _math;
            state.temperature_data.push(_max / 100)
          }
          state.temperature_data = state.temperature_data.filter(function (ele, pos) {
            return state.temperature_data.indexOf(ele) == pos;
          })
          if (state.temperature_start == 0) {
            state.temperature_start = state.temperature_data[0];
          } else if (state.temperature_start > state.temperature_data[state.temperature_data.length - 1]) {
            state.temperature_start = state.temperature_data[state.temperature_data.length - 1]
          } else if (state.temperature_start < state.temperature_data[0]) {
            state.temperature_start = state.temperature_data[0]
          }
        }
      }
      if (_mode == "HDR") {
        state.brightness_max_data = [];
        state.brightness_min_data = [];
        state.temperature_data = [];
        state.gamma_data = [];
        _difference_max = (state.APICalibrationData['brightness']['HDR']['range_max'] - state.APICalibrationData['brightness']['HDR']['range_min']) / 6
        for (a = 0; a <= 6; a++) {
          _math = 100;
          if (state.APICalibrationData['brightness']['HDR']['range_min'] / 100 < 1) {
            _math = 10
          }
          _max = Math.round((state.APICalibrationData['brightness']['HDR']['range_min'] + _difference_max * a) / _math) * _math;
          state.brightness_max_data.push(_max)
        }
        state.brightness_max_data = state.brightness_max_data.filter(function (ele, pos) {
          return state.brightness_max_data.indexOf(ele) == pos;
        })
        // 確保 brightness_max_data 從左到右、小到大排序
        state.brightness_max_data.sort((a, b) => a - b);
        state.bright_max = state.APICalibrationData['brightness_max']
        state.bright_min = state.APICalibrationData['brightness_min']
        if (state.brightness_max_start == 0) {
          state.brightness_max_start = state.brightness_max_data[0];
        } else if (state.brightness_max_start > state.brightness_max_data[state.brightness_max_data.length - 1] && !state.brightness_max_max) {
          state.brightness_max_start = state.brightness_max_data[state.brightness_max_data.length - 1];
        } else if (state.brightness_max_start > state.brightness_max_data[state.brightness_max_data.length - 1] && state.brightness_max_max && state.brightness_max_start != state.bright_max) {
          state.brightness_max_start = state.brightness_max_data[state.brightness_max_data.length - 1];
        }
        state.brightness_max_max = state.APICalibrationData['brightness']['HDR']['max']
        state.brightness_max_min = state.APICalibrationData['brightness']['HDR']['min']
        state.brightness_max_step = state.APICalibrationData['brightness']['HDR']['step']
        // if (state.APICalibrationData['color_temperature']['HDR']['fix']) {
        //   state.temperature_lock = true;
        //   state.temperature_start = state.APICalibrationData['color_temperature']['HDR']['fix'] / 100
        //   _difference_max = (10000 - 4000) / 6
        //   for (a = 0; a <= 6; a++) {
        //     _max = Math.round((4000 + _difference_max * a) / 100) * 100;
        //     state.temperature_data.push(_max / 100)
        //   }
        //   state.temperature_data = state.temperature_data.filter(function (ele, pos) {
        //     return state.temperature_data.indexOf(ele) == pos;
        //   })
        // } else 
        if (state.APICalibrationData['color_temperature']['step']) {
          state.temperature_lock = false;
          _difference_max = (state.APICalibrationData['color_temperature']['range_max'] - state.APICalibrationData['color_temperature']['range_min']) / 6
          for (a = 0; a <= 6; a++) {
            _math = 100;
            if (state.APICalibrationData['color_temperature']['range_min'] / 100 < 1) {
              _math = 10
            }
            _max = Math.round((state.APICalibrationData['color_temperature']['range_min'] + _difference_max * a) / _math) * _math;
            state.temperature_data.push(_max / 100)
          }
          state.temperature_data = state.temperature_data.filter(function (ele, pos) {
            return state.temperature_data.indexOf(ele) == pos;
          })
          if (state.temperature_start == 0) {
            state.temperature_start = state.temperature_data[0];
          } else if (state.temperature_start > state.temperature_data[state.temperature_data.length - 1]) {
            state.temperature_start = state.temperature_data[state.temperature_data.length - 1]
          } else if (state.temperature_start < state.temperature_data[0]) {
            state.temperature_start = state.temperature_data[0]
          }
        }
      }
      if (_mode == "SDR") {
        state.brightness_max_data = [];
        state.brightness_min_data = [];
        state.temperature_data = [];
        state.gamma_data = [];
        if (state.EOTF.text == "Gamma") {
          state.gamma_data = state.gamma_data_default;
          if (state.gamma_start == 0) {
            state.gamma = state.gamma_data[0];
          } else if (state.gamma_start < state.gamma_data[0]) {
            state.gamma_start = state.gamma_data[0];
          } else if (state.gamma_start > state.gamma_data[state.gamma_data.length - 1]) {
            state.gamma_start = state.gamma_data[state.gamma_data.length - 1]
          }
        }
        _difference_max = (state.APICalibrationData['brightness']['SDR']['range_max'] - state.APICalibrationData['brightness']['SDR']['range_min']) / 6
        for (a = 0; a <= 6; a++) {
          _math = 100;
          if (state.APICalibrationData['brightness']['SDR']['range_min'] / 100 < 1) {
            _math = 10
          }
          _max = Math.round((state.APICalibrationData['brightness']['SDR']['range_min'] + _difference_max * a) / _math) * _math;
          state.brightness_max_data.push(_max)
        }
        // state.brightness_max = state.brightness_max_data[0];
        state.brightness_max_data = state.brightness_max_data.filter(function (ele, pos) {
          return state.brightness_max_data.indexOf(ele) == pos;
        })
        // 確保 brightness_max_data 從左到右、小到大排序
        state.brightness_max_data.sort((a, b) => a - b);
        if (state.brightness_max_start == 0) {
          state.brightness_max_start = state.brightness_max_data[0];
        } else if (state.brightness_max_start > state.brightness_max_data[state.brightness_max_data.length - 1] && !state.brightness_max_max) {
          state.brightness_max_start = state.brightness_max_data[state.brightness_max_data.length - 1];
        } else if (state.brightness_max_start > state.brightness_max_data[state.brightness_max_data.length - 1] && state.brightness_max_max && state.brightness_max_start != state.bright_max) {
          state.brightness_max_start = state.brightness_max_data[state.brightness_max_data.length - 1];
        }
        state.bright_max = state.APICalibrationData['brightness_max']
        state.bright_min = state.APICalibrationData['brightness_min']
        state.brightness_max_max = state.APICalibrationData['brightness']['SDR']['max']
        state.brightness_max_min = state.APICalibrationData['brightness']['SDR']['min']
        state.brightness_max_step = state.APICalibrationData['brightness']['SDR']['step']
        // if (state.APICalibrationData['color_temperature']['SDR']['fix']) {
        //   state.temperature_lock = true;
        //   state.temperature_start = state.APICalibrationData['color_temperature']['SDR']['fix'] / 100
        //   _difference_max = (10000 - 4000) / 6
        //   for (a = 0; a <= 6; a++) {
        //     _max = Math.round((4000 + _difference_max * a) / 100) * 100;
        //     state.temperature_data.push(_max / 100)
        //   }
        //   state.temperature_data = state.temperature_data.filter(function (ele, pos) {
        //     return state.temperature_data.indexOf(ele) == pos;
        //   })
        // } else 
        if (state.APICalibrationData['color_temperature']['step']) {
          state.temperature_lock = false;
          _difference_max = (state.APICalibrationData['color_temperature']['range_max'] - state.APICalibrationData['color_temperature']['range_min']) / 6
          for (a = 0; a <= 6; a++) {
            _math = 100;
            if (state.APICalibrationData['color_temperature']['range_min'] / 100 < 1) {
              _math = 10
            }
            _max = Math.round((state.APICalibrationData['color_temperature']['range_min'] + _difference_max * a) / _math) * _math;
            state.temperature_data.push(_max / 100)
          }
          state.temperature_data = state.temperature_data.filter(function (ele, pos) {
            return state.temperature_data.indexOf(ele) == pos;
          })
          if (state.temperature_start == 0) {
            state.temperature_start = state.temperature_data[0];
          } else if (state.temperature_start > state.temperature_data[state.temperature_data.length - 1]) {
            state.temperature_start = state.temperature_data[state.temperature_data.length - 1]
          } else if (state.temperature_start < state.temperature_data[0]) {
            state.temperature_start = state.temperature_data[0]
          }
        }
      }
      // console.log("calibration state", state);
    }
    const IsChecked = computed({
      get: () => isCheck,
      set: (val) => {
        emit('update:isCheck', val);
      }
    })

    const coordinateInit = (coordinate = undefined) => { // pppp
      if (coordinate) {
        state.coordinateEnum['XMin'] = coordinate['x']['range_min'].toString()
        state.coordinateEnum['YMin'] = coordinate['y']['range_min'].toString()
        state.coordinateEnum['XMax'] = coordinate['x']['range_max'].toString()
        state.coordinateEnum['YMax'] = coordinate['y']['range_max'].toString()
        state.coordinateEnum['XDefault'] = coordinate['x']['default'].toString()
        state.coordinateEnum['YDefault'] = coordinate['y']['default'].toString()
        state.coordinate['x'] = coordinate['x']['default'].toString()
        state.coordinate['y'] = coordinate['y']['default'].toString()
      } else {
        state.coordinate['x'] = state.coordinateEnum['XDefault'].toString()
        state.coordinate['y'] = state.coordinateEnum['YDefault'].toString()
      }
    }
    onMounted(() => {
      console.log('storeState.calibrationList', storeState.calibrationList,)
      getAPITablesDataGroup() //取得add group popup的清單
      getAPITablesData();
      coordinateInit()
      // getAPIGetGroupModel();
      //#region get data
      if (storeState.calibrationList.title) { //在device或group頁面被選到要進入color calibration頁的list
        var _data = storeState.calibrationList;

        console.log('ffds', _data)
        if (_data.title == "group") {
          state.nextTitle = _data.title;
          state.nextData = _data.next;
          state.scaleType = 'Groups';
          console.log('state.nextData ', state.nextData)
          //從gorup management來要可以選多個group帶過來一起預約，不同model的阻擋popup在group management那邊已經做好
          for (let i = 0; i < _data.content.length; i++) {
            let _d = {
              name: _data.content[i].name,
              "Model Name": _data.content[i].model,
              "__d7d_n17r.__devicesInTotal": _data.content[i].device_count,
              "__d7d_n17r.__modelName": _data.content[i].model,
              // "__d7d_n17r.__devicesInTotal": _data.content[i].device_count,
              "val": _data.content[i].id,
            }
            state.dataToMulti.push(_d);
          }
          state.model = state.dataToMulti[0]["Model Name"]
        } else if (_data.title == "device") {
          state.nextTitle = _data.title
          state.nextData = _data.content
          console.log(_data);
          state.dataToMulti = [];
          for (var a = 0; a < _data.content.length; a++) {
            var _d = {
              name: _data.content[a].ssn,
              val: _data.content[a].ssn,
              "Model Name": _data.content[a].model,
              "__d7d_n17r.__modelName": _data.content[a].model,
              "__d7d_n17r.__pcName": _data.content[a].host,
              "__d7d_n17r.__ipAddress": _data.content[a].ip,
            }
            state.dataToMulti.push(_d);
          }
          state.model = state.dataToMulti[0]["Model Name"]
        } else if (_data.title == "target") {
          // console.log(storeState.calibrationList,'storeState.calibrationList')
          // 只有在有 dataToMulti 資料時才設置 model
          if (state.dataToMulti && state.dataToMulti.length > 0) {
            state.model = _data.content.modelName;
          }
        }
        if (state.model && state.dataToMulti && state.dataToMulti.length > 0) {
          getAPICalibrationData();
        }
        store.commit('setCalibrationList', {});
      } else {
        // 第一次進入頁面時，如果沒有從其他頁面帶來的資料，需要等待 API 資料載入完成後初始化
        // 這個邏輯會在 getAPIGetGroupModel 完成後觸發
      }
      //#endregion
    })
    const saveData = (output) => { //存在store
      var _data = {
        model: state.model,
      }
      _data["mode"] = null;
      _data["user_target_name"] = null;
      _data["preset_target"] = null;
      _data["color_range"] = null;
      _data["gamut"] = null;
      _data["gamut_custom"] = null;
      _data["eotf"] = null;
      _data["brightness"] = null;
      _data["brightness_min"] = null;
      _data["color_temperature"] = null;
      _data["gamma"] = null;
      _data["group_id"] = null;
      _data["devices"] = null;
      _data["whitePointDisable"] = null;
      _data["color_temperature"] = null;
      _data["color_standard"] = null; // white point Standard value




      switch (state.selectedVal) {
        case USERMODE[0]:
          _data["mode"] = 0
          break;
        case USERMODE[1]:
          _data["mode"] = 1
          break;
        case USERMODE[2]:
          _data["mode"] = 2
          break;
        case USERMODE[3]:
          _data["mode"] = 3
          break;
      }
      if (_data["mode"] == 0) {
        var _preset_target = [];
        var _color_range = "";
        for (var a = 0; a < state.card.length; a++) {
          if (state.card[a]["click"]) {
            _preset_target.push(state.card[a]["id"]);
            if (_color_range == "") {
              _color_range = state.card[a]["color_range"]
            } else if (_color_range != state.card[a]["color_range"]) {
              _color_range = "HDR_SDR"
            }
          }
        }
        _data["preset_target"] = _preset_target;
        if (_color_range == "SDR") {
          _data["color_range"] = 0;
        } else if (_color_range == "HDR") {
          _data["color_range"] = 1;
        } if (_color_range == "HDR_SDR") {
          _data["color_range"] = 2;
        }
      } else if (_data["mode"] == 1 || _data["mode"] == 2 || _data["mode"] == 3) {
        _data["brightness"] = state.brightness_max;
        _data["user_target_name"] = output;
        var _target = state.target_op[state.target_op.map(x => x.val).indexOf(state.target.val)];
        if (_target.color_range == "SDR") {
          _data["color_range"] = 0
        } else if (_target.color_range == "HDR") {
          _data["color_range"] = 1
        }
        // 處理 Gamut 設定
        if (state.gamutType === 'customized') {
          // Customized Gamut: 設定為 7，並帶入 gamut_custom
          _data["gamut"] = 7;
          // _data["gamut_text"] = "Customized";
          // 轉換 customGamut -> gamut_custom (只含 red_y, green_x, green_y, blue_x, blue_y)
          _data["gamut_custom"] = getCustomGamutData();
          console.log('Customized Gamut: setting gamut_custom', _data["gamut_custom"]);
        } else {
          _data["gamut"] = state.gamut.val;
        }
        if (state.brightness_min_data.length > 0) {
          _data["brightness_min"] = state.brightness_min;
        }
        if (state.gamma_data.length > 0) {
          _data["gamma"] = state.gamma;
        }
        // if (state.temperature_data.length > 0) {
        //   _data["color_temperature"] = state.temperature/100;
        // }
        console.log('_data["color_temperature"]', _data["color_temperature"])
        _data["eotf"] = state.EOTF.val;

        ///嚴重coordinate
        _data["whitePointDisable"] = state.whitePointDisable;
        if (state.whitePointSelect === 'colorTemperature') {
          if (state.temperature_data.length > 0) {
            _data["color_temperature"] = state.temperature / 100;
          }
        } else if (state.whitePointSelect === 'coordinate') {
          if (state.coordinate['x'] && state.coordinate['y']) {
            _data["coordinate"] = state.coordinate;
          }
        } else if (state.whitePointSelect === 'standard') {
          _data["color_standard"] = state.color_standard.val;
        }
      }
      if (state.dataToMulti.length > 0) {

        if (state.dataToMulti[0]["__d7d_n17r.__devicesInTotal"]) { //group 中至少要有一個device
          try {//待修正
            let temp = Object.values(state.dataToMulti).map(item => item.val);
            console.log('temp 新增多個 group 的清單 ', temp)
            // var group_id = state.group_op[state.group_op.map(x => x.text).indexOf(state.dataToMulti[0]["name"])].val;
            _data["group_id"] = temp;
          } catch {
            _data["group_id"] = "03dc89ba-f9e5-4e50-9ddb-b153194d0503"
          }
        } else if (state.dataToMulti[0]["Model Name"]) {
          _data["devices"] = []
          state.dataToMulti.forEach(element => {
            _data["devices"].push(element.name)
          });
        }
      }
      store.commit('setCalibrationPostData', _data);
      console.log("James hahahah", _data)
      router.push(`/${"main/calibration/advanced"}`);
    }
    const router = useRouter();
    const backHere = async () => {
      //#region back here
      if (storeState.isBackToCalibration) {
        // store.commit('backToCalibration', false);
        console.log(storeState.calibrationPostData, 'storeState.calibrationPostData')
        if (storeState.calibrationPostData.devices) {
          if (storeState.calibrationPostData.devices.length > 0) {
            storeState.calibrationPostData.devices.forEach(element => {
              var _device = state.popup_table_date[state.popup_table_date.map(x => x.serialNumber).indexOf(element)];
              var _d = {
                name: _device.serialNumber,
                "Model Name": _device.model,
                "__d7d_n17r.__modelName": _device.model,
                "__d7d_n17r.__pcName": _device.pcName,
                "__d7d_n17r.__ipAddress": _device.ip,
              }
              // console.log('fff', _d)
              state.dataToMulti.push(_d);
            });
            state.model = storeState.calibrationPostData.model;
            if (state.model && state.dataToMulti && state.dataToMulti.length > 0) {
              getAPICalibrationData();
            }
          }
        }
        if (storeState.calibrationPostData.group_id) {
          let _group
          let _devices = 0;
          storeState.calibrationPostData.group_id.forEach(element => {
            console.log('從下一頁(advanced)回來的group id 清單', element)
            _group = state.group_op[state.group_op.map(x => x.val).indexOf(element)];
            for (var a = 0; a < state.popup_table_date.length; a++) {
              var _array = state.popup_table_date[a].group.split(",");
              var _isgroup = _array.indexOf(_group.text);
              if (_isgroup >= 0) {
                _devices++;
              }
            }
            var _d = {
              name: _group.text,
              "Model Name": storeState.calibrationPostData.model,
              "__d7d_n17r.__modelName": storeState.calibrationPostData.model,
              "__d7d_n17r.__devicesInTotal": _devices,
              'val': element,
            }
            // console.log('fff', _d)
            state.dataToMulti.push(_d);
          });

          console.log('從group來的完整清單', state.dataToMulti)

          state.model = storeState.calibrationPostData.model;
          if (state.model && state.dataToMulti && state.dataToMulti.length > 0) {
            getAPICalibrationData();
          }
        }
      }
      //#endregion
    }
    const backAndSet = async () => {
      if (state.gamut.text == state.target_op[0].gamut) {
        var _backdata = storeState.calibrationPostData;
        // console.log('!!!!!!!!change',_backdata)
        var _value = Object.values(state.APICalibrationData["gamut"]);
        _value.forEach(element => {
          var _key = Object.keys(element);
          var _val = Object.values(element);
          for (var a = 0; a < _key.length; a++) {
            if (_val[a] == _backdata.gamut) {
              state.gamut = { text: _key[a], val: _val[a] };
            }
          }
        });
        state.target = {
          text: "Customized",
          val: state.target.val,
          isI18n: '__c3r_c9n.__customized',
        }
        // console.log('!!!!!!!!',state.EOTF_op_default)
        for (var a = 0; a < state.EOTF_op_default.length; a++) {
          if (state.EOTF_op_default[a]["sub"]) {
            for (var b = 0; b < state.EOTF_op_default[a]["sub"].length; b++) {
              if (_backdata.eotf == state.EOTF_op_default[a]["sub"][b].val) {
                if (a == 0 && b == 0) {
                  if (_backdata.brightness) {
                    state.brightness_max_start = _backdata.brightness
                  }
                  if (_backdata.brightness_min) {
                    state.brightness_min_start = _backdata.brightness_min
                  }
                  //coordinate start
                  state.whitePointSelect = _backdata.whitePointDisable == 2 ? 'colorTemperature' :
                    _backdata.whitePointDisable == 1 ? 'coordinate' : 'standard';
                  if (_backdata.color_temperature) {
                    state.temperature_start = _backdata.color_temperature
                  }

                  if (_backdata.coordinate) {
                    state["coordinate"] = _backdata.coordinate;
                  }
                  //coordinate end


                  if (_backdata.gamma) {
                    state.gamma_start = _backdata.gamma
                  }


                  store.commit('backToCalibration', false);
                } else {
                  state.EOTF = state.EOTF_op_default[a]["sub"][b];
                }
              }
            }
          }
        }
      } else {
        setTimeout(() => {
          backAndSet();
        }, 500);
      }
    }
    const getAPITablesDataGroup = async () => {
      // console.log('看走位 2 getAPIGetGroupModel')
      const sendData = {
        page: 1,
        per_page: 99999999,

      }
      try {
        const datas = await apiGroup(sendData);
        console.log('apiGroup!!!!', datas)
        if (!datas.status_code) {
          for (let i = 0; i < datas.data.length; i++) {
            datas.data[i].connection = `${datas.data[i].device_online_count} / ${datas.data[i].device_offline_count}`
          }
          state.popup_table_data_group = datas.data
        }

      }
      catch (error) {
        return error;
      }

    }
    //#region API
    const getAPITablesData = async () => {
      try {
        var _send = {
          page: 1,
          per_page: 99999999,
        }
        const data = await apiGetDevice(_send);
        console.log('table data', data);
        state.popup_table_date = [];
        //資料ready前防止使用者誤觸按鈕 start 需要延續到 outline(getAPIGetGroupModel)
        if (data) store.commit('setIsLoading', true);
        //資料ready前防止使用者誤觸按鈕 start
        var _data = data.data;
        for (var a = 0; a < _data.length; a++) {
          var group = "";
          for (var b = 0; b < _data[a].group.length; b++) {
            if (b == _data[a].group.length - 1) {
              group += _data[a].group[b]
            } else {
              group += _data[a].group[b] + "; "
            }
          }
          var _table = {
            serialNumber: _data[a].ssn,
            model: _data[a].model,
            pcName: _data[a].host,
            group: group,
            groupArr: _data[a].group,
            connectionStatus: _data[a].status,
            ip: _data[a].ip,
            appointment_count: _data[a].appointment_count
          }
          if (_data[a].status != 2) {
            state.popup_table_date.push(_table);
          }
        }
        if (storeState.isBackToCalibration && storeState.calibrationPostData.devices) {
          console.log('123 backHere', state.popup_table_date)
          state.scaleType = 'Devices'; //從下一頁(advance)回來要改device or group   radio狀態
          backHere();
        }
        getAPIGetGroupModel();
      }
      catch (err) {
        console.log('err')
      }
    }
    const getAPICalibrationData = async () => {
      try {
        var _d = {
          model: state.model
        }
        const data = await apiGetCalibration(_d);
        console.log('Calibration data', data.data);
        state.APICalibrationData = data.data;
        // 從 API 更新 gamut_op 選項
        state.gamut_op = [];
        const gamutData = data.data.gamut;
        if (gamutData) {
          const keys = Object.keys(gamutData);
          const values = Object.values(gamutData);

          for (var i = 0; i < keys.length; i++) {
            state.gamut_op.push({
              text: keys[i],
              val: values[i] as number
            });
          }
        }
        //從API 更新 color_standard
        state.color_standard_op = [];
        const colorStandardData = data.data.color_standard;
        if (colorStandardData) {
          const keys = Object.keys(colorStandardData);
          const values = Object.values(colorStandardData);
          for (var i = 0; i < keys.length; i++) {
            state.color_standard_op.push({
              text: keys[i],
              val: values[i] as number
            });
          }
        }

        orgDicomOP()
        //#region set target
        var _model = data.data.model.user_modes;
        state.target_op = [];
        for (var _m = 0; _m < _model.length; _m++) {
          var _target = {
            text: _model[_m].name,
            val: _m,
            gamut: _model[_m].gamut,
            gamma: _model[_m].gamma,
            brightness: _model[_m].brightness,
            brightness_min: _model[_m].brightness_min,
            color_temperature: _model[_m].color_temperature,
            eotf: _model[_m].eotf,
            color_range: _model[_m].color_range,
            coordinate: data.data.color_xy,
          }
          state.target_op.push(_target);
        }
        _model = data.data.cloud_targets;
        for (_m = 0; _m < _model.length; _m++) {
          _target = {
            text: _model[_m].name,
            val: _model[_m].id,
            gamut: _model[_m].gamut,
            gamma: _model[_m].gamma,
            brightness: _model[_m].brightness,
            brightness_min: _model[_m].brightness_min,
            color_temperature: _model[_m].color_temperature,
            eotf: _model[_m].eotf,
            color_range: _model[_m].color_range,
            gamut_custom: _model[_m].gamut_custom,
            color_standard: _model[_m].color_standard, // white point Standard value
            coordinate: data.data.color_xy,
          } as any
          state.target_op.push(_target);
        }
        if (storeState.calibrationList.title == "target") {
          var _t = state.target_op.map(x => x.val).indexOf(storeState.calibrationList.content.dataInfo[0].id);
          if (_t == -1) {
            state.isTargetSwitching = true; // 標記開始切換 target
            state.target = {
              text: state.target_op[0].text,
              val: state.target_op[0].val,
              isI18n: undefined,
            };
            // 根據 target_op[0] 的 gamut 找到對應的 gamut_op 選項
            const gamutOption = state.gamut_op.find(option => option.text === state.target_op[0].gamut);
            if (gamutOption) {
              state.gamut = gamutOption;
            } else {
              state.gamut = { text: state.target_op[0].gamut, val: 0 };
            }
            state.isTargetSwitching = false; // 標記結束切換 target
          } else {
            state.isTargetSwitching = true; // 標記開始切換 target
            state.target = {
              text: state.target_op[_t].text,
              val: state.target_op[_t].val,
              isI18n: undefined,
            };
            // 根據 target_op[_t] 的 gamut 找到對應的 gamut_op 選項
            const gamutOption = state.gamut_op.find(option => option.text === state.target_op[_t].gamut);
            if (gamutOption) {
              state.gamut = gamutOption;
            } else {
              state.gamut = { text: state.target_op[_t].gamut, val: 0 };
            }
            state.isTargetSwitching = false; // 標記結束切換 target
          }
        } else {
          state.isTargetSwitching = true; // 標記開始切換 target
          state.target = {
            text: state.target_op[0].text,
            val: state.target_op[0].val,
            isI18n: undefined,
          };
          // state.gamut = state.target_op[0].gamut;
          state.isTargetSwitching = false; // 標記結束切換 target
        }

        //colorXY start
        if (data.data.color_xy) {
          coordinateInit(data.data.color_xy)
        }
        //colorXY end




        //#endregion
        //#region EOTF
        state.EOTF_op_default = [];
        var _eotf = data.data.eotf;
        var _key_1 = Object.keys(_eotf);
        var _object_1 = Object.values(_eotf);
        var start = null;
        for (var _e = 0; _e < _key_1.length; _e++) {
          var _key_2 = Object.keys(_object_1[_e])
          var _object_2 = Object.values(_object_1[_e]);
          var _EOTF_op = {
            text: _key_1[_e],
            val: _key_1[_e],
            sub: []
          }
          for (var _e2 = 0; _e2 < _key_2.length; _e2++) {
            var _op = {
              text: _key_2[_e2],
              val: _object_2[_e2]
            }
            if (start == null) {
              start = _op;
            }
            _EOTF_op.sub.push(_op);
          }
          state.EOTF_op_default.push(_EOTF_op);
        }
        state.EOTF = start;
        //#endregion
        if (storeState.isBackToCalibration) {
          // console.log('????ORG',storeState.calibrationPostData)
          var _backdata = storeState.calibrationPostData;
          if (_backdata.mode == 1 || _backdata.mode == 2 || _backdata.mode == 3) {
            state.whitePointSelect = _backdata.whitePointDisable == 2 ? 'colorTemperature' : 'coordinate';
            // state.selectedVal = "User Mode " + _backdata.mode;
            state.selectedVal = USERMODE[_backdata.mode]
            // if (_backdata.user_target_name != "__c3r_c9n.__customized") {
            if (_backdata.user_target_name != "Customized") {
              var _backTarget = state.target_op[state.target_op.map(x => x.text).indexOf(_backdata.user_target_name)];
              state.target = {
                text: _backTarget.text,
                val: _backTarget.val,
                isI18n: undefined,
              };
              // state.gamut = _backTarget.gamut;
              store.commit('backToCalibration', false);
            } else {
              backAndSet();
            }
          }
        }
        //#region card
        state.card = [];
        var _preset = data.data.model.preset_modes;
        for (var p = 0; p < _preset.length; p++) {
          var _card = {
            name: _preset[p].name,
            gamma: _preset[p].gamma,
            color: _preset[p].color_temperature,
            brightness: `${_preset[p].brightness} ${UNIT.NTM2}`,
            click: false,
            color_range: _preset[p].color_range,
            eotf: _preset[p].eotf,
            id: _preset[p].id,
          };
          state.card.push(_card);
        }
        if (storeState.isBackToCalibration) {
          if (_backdata.mode == 0) {
            state.selectedVal = USERMODE[0];
            _backdata.preset_target.forEach(val => {
              state.card[val].click = true;
            });
            store.commit('backToCalibration', false);
          }
        }
        //#endregion

        // 只有在有選擇 device 或 group 時才啟用所有控制項
        console.log('getAPICalibrationData - dataToMulti.length:', state.dataToMulti ? state.dataToMulti.length : 'undefined');
        if (state.dataToMulti && state.dataToMulti.length > 0) {
          state.disable_all = false;
          console.log('getAPICalibrationData - disable_all set to false');
        } else {
          state.disable_all = true;
          console.log('getAPICalibrationData - disable_all set to true');
        }

      }
      catch (err) {
        console.log('err')
      }
    }
    const orgDicomOP = async () => { //整理dicom 的下拉選單
      state.APICalibrationData['gamut'].SDR

      for (const key in state.APICalibrationData['gamut'].SDR) {
        state.dicomSelect_op.push({
          'text': key,
          'val': state.APICalibrationData['gamut'].SDR[key]
        })
      }
      state.dicomGamut = state.dicomSelect_op[0]
      // console.log('state.dicomSelect_op',state.dicomSelect_op)
    }
    const getAPIGetGroupModel = async () => {
      // console.log('看走位 1 getAPIGetGroupModel')
      try {
        const data = await apiGetGroupModel();
        // console.log('Group api data', data);
        //資料ready前防止使用者誤觸按鈕 start
        if (data) store.commit('setIsLoading', true);
        //資料ready前防止使用者誤觸按鈕 start
        //#region set device_op
        state.device_op = [
          {
            text: t('__d7d_n17r.__allDevices'),
            val: 'All',
            isI18n: '__d7d_n17r.__allDevices',
          },
        ]
        var devices = {
          text: t('__d7d_n17r.__modelName'),
          val: "Model Name",
          isI18n: '__d7d_n17r.__modelName',
        }
        devices["sub"] = [];
        for (var m = 0; m < data.model.length; m++) {
          var _device = {
            text: data.model[m],
            val: data.model[m],
          }
          devices["sub"].push(_device);
        }
        state.device_op.push(devices);
        var _status = {
          text: t('__d7d_n17r.__connectionStatus'),
          val: "Connection Status",
          isI18n: '__d7d_n17r.__connectionStatus',
        }
        _status["sub"] = [
          {
            text: t('__g3p_m8t.__online'),
            val: "1",
            isI18n: '__g3p_m8t.__online',
          },
          {
            text: t('__g3p_m8t.__offline'),
            val: "0",
            isI18n: '__g3p_m8t.__offline',
          },
        ]
        state.device_op.push(_status);
        //#endregion
        //#region set group_op
        state.group_op = [
          {
            text: t('__common.__all'),
            val: "All",
            isI18n: '__common.__all',
          }
        ];
        for (var g = 0; g < data.groups.length; g++) {
          var _group = {
            text: data.groups[g].name,
            val: data.groups[g].id
          }
          state.group_op.push(_group);
        }
        if (storeState.isBackToCalibration && storeState.calibrationPostData.group_id) {
          state.scaleType = 'Groups'; //從下一頁(advance)回來要改device or group   radio狀態
          backHere();
        }
        //#endregion
        //資料ready前防止使用者誤觸按鈕 end
        store.commit('setIsLoading', false);
        //資料ready前防止使用者誤觸按鈕 end

        // 第一次進入頁面時，如果沒有 model 資料，不要自動初始化
        // 應該要讓使用者先新增 Device，然後才能調整參數
        if (!state.model && data.model && data.model.length > 0) {
          // 不自動設定 model，保持 disable_all = true
          // 使用者需要先新增 Device 才能調整參數
        }
      }
      catch (err) {
        console.log('err')
      }
    }
    const setAPITargetList = () => {
      let _target = state.target_op[state.target_op.map(x => x.val).indexOf(state.target.val)];
      let _send = {
        model: state.model,
        eotf: state.EOTF.val,
        brightness: state.brightness_max,
        color_x: state.coordinate.x,
        color_y: state.coordinate.y,
      }
      if (_target.color_range == "SDR") {
        _send["color_range"] = 0
      } else if (_target.color_range == "HDR") {
        _send["color_range"] = 1
      }
      // _send["gamut"] = state.gamut
      //原本ginter寫的是放值，現在放key 就行了
      console.log('state.gamut', state.gamut)
      if (state.gamutType === "customized") {
        _send["gamut"] = 7;
        _send["gamut_custom"] = getCustomGamutData();
        console.log('Customized Gamut: setting gamut_custom', _send["gamut_custom"]);
      } else {
        _send["gamut"] = state.gamut.val;
        // _send["gamut_text"] = state.gamut.text;
      }
      if (state.brightness_min_data.length > 0) {
        _send["brightness_min"] = state.brightness_min;
      }
      if (state.gamma_data.length > 0) {
        _send["gamma"] = state.gamma;
      }
      ///嚴重
      _send["whitePointDisable"] = state.whitePointDisable;
      if (state.whitePointSelect === 'colorTemperature') {
        if (state.temperature_data.length > 0) {
          _send["color_temperature"] = state.temperature;
        }
        _send["color_x"] = null
        _send["color_y"] = null
        _send["color_standard"] = null;
      } else if (state.whitePointSelect === 'coordinate') {
        if (state.coordinate['x'] && state.coordinate['y']) {
          _send["coordinate"] = state.coordinate;
        }
        _send["color_temperature"] = null;
        _send["color_standard"] = null;
      } else if (state.whitePointSelect === 'standard') {
        _send["color_standard"] = state.color_standard.val;
        _send["color_temperature"] = null;
        _send["color_x"] = null
        _send["color_y"] = null
      }
      _send["nameError"] = false;
      return _send
    }
    const getAPIGroupDeviceList = async (name) => {
      //選多個group時，因為model已經在popup中比對過是同一個model，所以可以用其中一個group去取model
      //這隻可以考慮刪掉，因為 model之前就會知道了
      try {
        var data = await apiGroupDeviceList(name);
        console.log('group', data);
        state.nextData = data.data
        state.nextTitle = 'group'
        state.model = data.model;
        if (state.dataToMulti && state.dataToMulti.length > 0) {
          getAPICalibrationData();
        }
      }
      catch (err) {
        console.log("apiGroupDeviceList", 'err')
      }
    }
    //#endregion
    //#region Popup
    const store = useStore();
    const storeState = store.state;



    const showModal = () => {
      let _defaultCheck = [];
      if (state.scaleType == 'Devices') {
        state.dataToMulti.forEach(e => { //檢查清單中是否有的device
          let t = state.popup_table_date.map(x => x.serialNumber).indexOf(e.name);
          if (t != -1) {
            _defaultCheck.push(t);
          }
        });
        const modalConfig = {
          type: POPUP.CUSTOMIZED,
          data: {
            col: popup_table_title,
            list: state.popup_table_date,
            defaultCheck: _defaultCheck,
            group_op: state.group_op,
            device_op: state.device_op,
            isgroup: '', //g原本有group的流程，用來判斷group 只能一個，且沒有device的情況的參數，先保留
          },
          isShow: true,
        }
        store.commit('setIsShowModal', modalConfig)
      } else { //檢查清單中是否有的group
        state.dataToMulti.forEach(e => {
          let t = state.popup_table_data_group.map(x => x.name).indexOf(e.name);
          if (t != -1) {
            _defaultCheck.push(t);
          }
        });
        let disableCheck = state.popup_table_data_group.map((e) => {
          return !e.device_count
        })
        const modalConfig = {
          type: POPUP.CUSTOMIZEDGROUP,
          data: {
            col: popup_table_title_group,
            list: state.popup_table_data_group,
            defaultCheck: _defaultCheck,
            isgroup: '',
            disableCheck: disableCheck,
          },
          isShow: true,
        }
        store.commit('setIsShowModal', modalConfig)
      }
    }



    const showerror = () => {
      const modalConfig = {
        type: POPUP.DEVICEMODELERROR,
        data: {

        },
        isShow: true,
      }
      store.commit('setIsShowModal', modalConfig)
    }
    const onClick = () => {
      let isOverFlow = checkAppointment()
      if (isOverFlow) return
      console.log('isOverFlow', isOverFlow)
      if (state.selectedVal == t('__d4e_m8t.__presetMode', { brand: brand.value })) {
        saveData("")
        // console.log(router)
      } else if (state.target.text == "Customized") {//判斷都用 text ，多國語系另外有變數(i18n)操控
        var _data = setAPITargetList();
        const modalConfig = {
          type: POPUP.SAVECUSTOMIZED,
          data: _data,
          isShow: true,
        }
        store.commit('setIsShowModal', modalConfig)
      } else {
        console.log("james saveData ", state.target.text)
        saveData(state.target.text)
      }
    }
    const checkAppointment = () => {
      let overFlowDevice = []
      console.log(state.nextData)
      for (let i = 0; i < state.nextData.length; i++) {
        console.log('appointment_count', state.nextData[i].appointment_count)
        if (state.nextData[i].appointment_count >= 80) {
          overFlowDevice.push(
            `${state.nextData[i].model}_${state.nextData[i].host ? state.nextData[i].host : state.nextData[i].pcName}`
          )
        }
      }
      if (overFlowDevice.length) {
        const modalConfig = {
          type: POPUP.OVERFLOW,
          data: {
            list: overFlowDevice
          },
          isShow: true,
        }
        store.commit('setIsShowModal', modalConfig)
      }
      return overFlowDevice.length > 0

    }

    const gamutOnChange = () => {

      state.target = { //APP 端是一切換選單就Customized，不會再變回來
        text: "Customized",
        val: state.target.val,
        isI18n: '__c3r_c9n.__customized',
      }
    }

    // 抽取 Customized Gamut 座標轉換邏輯
    const getCustomGamutData = () => {
      const rx = state.customGamut?.red?.x;
      const ry = state.customGamut?.red?.y;
      const gx = state.customGamut?.green?.x;
      const gy = state.customGamut?.green?.y;
      const bx = state.customGamut?.blue?.x;
      const by = state.customGamut?.blue?.y;
      const toNum = (v) => (v === undefined || v === null || v === '' ? null : parseFloat(v));

      return {
        red_x: toNum(rx),
        red_y: toNum(ry),
        green_x: toNum(gx),
        green_y: toNum(gy),
        blue_x: toNum(bx),
        blue_y: toNum(by),
      };
    }

    const gamutTypeOnChange = (value) => {
      // 更新 gamutType 的值
      state.gamutType = value;
      state.target = {
        text: "Customized",
        val: state.target.val,
        isI18n: '__c3r_c9n.__customized',
      }
    }

    const colorStandardOnChange = () => {
      // 當 Standard Value 選擇變更時的處理邏輯
      state.target = {
        text: "Customized",
        val: state.target.val,
        isI18n: '__c3r_c9n.__customized',
      }
      console.log('Standard Value changed to:', state.color_standard);
    }

    const whitePointSelectOnChange = (value) => {
      // 當 White Point Radio Button 選擇變更時，將 Target 設為 Customized
      state.target = {
        text: "Customized",
        val: state.target.val,
        isI18n: '__c3r_c9n.__customized',
      }
      console.log('White Point changed to:', value);
    }


    // 格式化座標值到小數點第4位並限制範圍
    const formatCoordinate = (value, color, axis) => {
      if (value === null || value === undefined || value === '') {
        return '';
      }
      const num = parseFloat(value);
      if (isNaN(num)) {
        return '';
      }

      // 定義各顏色的範圍限制
      const ranges = {
        red: { x: [0.5500, 0.7080], y: [0.2500, 0.4000] },
        green: { x: [0.1500, 0.4000], y: [0.5000, 0.7970] },
        blue: { x: [0.1310, 0.2000], y: [0.0460, 0.1700] }
      };

      // 獲取對應的範圍限制
      const range = ranges[color]?.[axis];
      if (range) {
        const [min, max] = range;
        const clampedNum = Math.max(min, Math.min(max, num));
        return clampedNum.toFixed(4);
      }

      // 如果沒有找到對應的範圍，使用預設的 0-1 限制
      const clampedNum = Math.max(0, Math.min(1, num));
      return clampedNum.toFixed(4);
    }

    // 處理座標輸入的格式化
    const handleCoordinateBlur = (color, axis, value) => {
      const formatted = formatCoordinate(value, color, axis);
      state.customGamut[color][axis] = formatted;
    }

    // 處理座標輸入的即時驗證
    const handleCoordinateInput = (color, axis, event) => {
      const value = event.target.value;
      // 只允許數字、小數點和負號
      let cleanValue = value.replace(/[^0-9.-]/g, '');
      // 只允許一個小數點
      const parts = cleanValue.split('.');
      if (parts.length > 2) {
        cleanValue = parts[0] + '.' + parts.slice(1).join('');
      }
      // 更新狀態而不是直接修改 DOM
      state.customGamut[color][axis] = cleanValue;
    }




    store.watch((state) => (state.isShowModal, state.modalType), (newType, oldType) => {
      // modal type
      if (oldType === POPUP.CUSTOMIZED) {
        // console.log('"""""""toreState.modalBtnType', storeState.modalBtnType);
        // modal btn type

        if ((storeState.modalBtnType).indexOf(BTN.CONFIRM) > -1) {
          if (storeState.isNextToAdvance) { //從advance回來這頁(保存advance的編輯)，又改device的話，不保留advance的資料
            store.commit('nextToAdvance', false);
          }

          let _send = storeState.modalOutput;
          // console.log('"""""""--------------', _send);

          const output = _send.data;
          state.nextData = _send.data
          state.nextTitle = _send.title

          let array = [];
          let _model = "start";

          if (_send.title) {
            for (let a = 0; a < output.length; a++) {
              if (a == 0) {
                _model = output[a].model
              } else if (_model != output[a].model) {
                _model = "";
              }
              let _array = {
                name: output[a].serialNumber,
                val: output[a].serialNumber,
                'Model Name': output[a].model,
                "__d7d_n17r.__modelName": output[a].model,
                "__d7d_n17r.__pcName": output[a].pcName,
                "__d7d_n17r.__ipAddress": output[a].ip,
              }
              array.push(_array)
            }
            // console.log("output",array)
            if (_model != "") {
              state.dataToMulti = array;
              if (state.dataToMulti.length > 0) {
                state.model = state.dataToMulti[0]["Model Name"]
                // console.log("model",state.model)
                getAPICalibrationData();
              } else {
                state.disable_all = true;

              }
            } else {
              showerror();
            }
            //測試新增多個devices用(看UI排版)
            // console.log('arrrrr',_model)
            // state.dataToMulti = array;
            // let aaaa = {
            //   'IP Address': "42.77.34.188",
            //   'Model Name': "PQ22UC",
            //   "PC Name": "AA1500072-PC",
            //   "name" : "LCLMFQ364518",
            //   "val" : "LCLMFQ364518",
            // }
            // for (let k = 0; k < 16; k++) {
            //   state.dataToMulti.push(aaaa)
            // }
            //測試用
            if (state.dataToMulti.length > 0) {
              state.model = state.dataToMulti[0]["Model Name"]
            }
          }
        }
      } //end: modal
    })


    //新增多個group 的popup按下去任後的行為
    store.watch((state) => (state.isShowModal, state.modalType), (newType, oldType) => {
      // modal type
      if (oldType === POPUP.CUSTOMIZEDGROUP) {
        // console.log('"""""""toreState.modalBtnType', storeState.modalBtnType);
        // modal btn type

        if ((storeState.modalBtnType).indexOf(BTN.CONFIRM) > -1) {
          if (storeState.isNextToAdvance) { //從advance回來這頁(保存advance的編輯)，又改device的話，不保留advance的資料
            store.commit('nextToAdvance', false);
          }

          let _send = storeState.modalOutput;
          // console.log('"""""""--------------', _send);
          const output = _send.data;
          state.nextData = _send.data
          state.nextTitle = _send.title

          let array = [];
          let _model = "start";

          if (_send.title) {
            for (let a = 0; a < output.length; a++) {
              if (a == 0) {
                _model = output[a].model
              } else if (_model != output[a].model) {
                _model = "";
              }
              let _array = {
                "__d7d_n17r.__modelName": output[a].model,
                "__d7d_n17r.__devicesInTotal": output[a].device_count,
                name: output[a].name,
                val: output[a].id,
                'Model Name': output[a].model,
              }
              array.push(_array)
            }
            // console.log("output",array)
            // console.log("_model",_model)
            if (_model != "") {
              state.dataToMulti = []
              state.dataToMulti = JSON.parse(JSON.stringify(array))
              if (state.dataToMulti.length > 0) {
                state.model = state.dataToMulti[0]["Model Name"]
                //   console.log("model",state.model)
                //選多個group時，因為model已經在popup中比對過是同一個model，所以可以用其中一個group去取model
                //這行為可以考慮替換掉，直接用getAPICalibrationData()，因為 model之前就會知道了
                getAPIGroupDeviceList(output[0].id);
              } else {
                state.disable_all = true;

              }
            } else {
              showerror();
            }
          }
        }
      } //end: modal
    })


    store.watch((state) => (state.isShowModal, state.modalType), (newType, oldType) => {
      // modal type
      if (oldType === POPUP.DEVICEMODELERROR) {
        console.log('toreState.modalBtnType', storeState.modalBtnType);
        // modal btn type
        showModal()
        if ((storeState.modalBtnType).indexOf(BTN.CONFIRM) > -1) {
          const output = storeState.modalOutput
          console.log("output", output);
        }
      } //end: modal
    })
    store.watch((state) => (state.isShowModal, state.modalType), (newType, oldType) => {
      // modal type
      if (oldType === POPUP.SAVECUSTOMIZED) {
        console.log('toreState.modalBtnType', storeState.modalBtnType);
        // modal btn type
        if ((storeState.modalBtnType).indexOf(BTN.CONFIRM) > -1) {
          const output = storeState.modalOutput
          // console.log('吼',output);
          saveData(output);
          // router.push(`/${"main/calibration/advanced"}`);
        }
      } //end: modal
    })

    //切換 group or device radio 要清空下方content
    store.watch((state) => (state.isShowModal, state.modalType), (newType, oldType) => {
      if (oldType === POPUP.CLEARDEVICEANDGROUP) {
        if ((storeState.modalBtnType).indexOf(BTN.CONFIRM) > -1) {
          state.dataToMulti = [];
          resetCalibration()
        } else {
          state.scaleType == 'Devices' ? state.scaleType = 'Groups' : state.scaleType = 'Devices'
        }
      }
    })
    //#endregion Popup
    watch( //state.EOTF
      () => state.EOTF, () => {
        if (state.isTargetSwitching) return; // 如果正在切換 target，不執行後續邏輯
        // console.log(state.EOTF)
        var _target = state.target_op[state.target_op.map(x => x.text).indexOf(state.target.text)];
        var _val = state.target_op[state.target_op.map(x => x.val).indexOf(state.target.val)];
        // console.log('?:P_{"?"{', _val , state.EOTF.text)
        if (!_val) return //切換group 或者 device 時清空所有選項，就會有空值的情況產生，需要return
        // 移除這個邏輯，避免循環觸發
        // 當 EOTF 改變時，不應該自動切換 target
        // 用戶應該手動選擇 Apply Target Settings
        if (storeState.isBackToCalibration) {
          var _backdata = storeState.calibrationPostData;
          if (_backdata.brightness) {
            state.brightness_max_start = _backdata.brightness
            state.brightness_max = _backdata.brightness // 同步更新實際參數值
          }
          if (_backdata.brightness_min) {
            state.brightness_min_start = _backdata.brightness_min
            state.brightness_min = _backdata.brightness_min // 同步更新實際參數值
          }
          if (_backdata.color_temperature) {
            state.temperature_start = _backdata.color_temperature
            state.temperature = _backdata.color_temperature // 同步更新實際參數值
          }
          if (_backdata.gamma) {
            state.gamma_start = _backdata.gamma
            state.gamma = _backdata.gamma // 同步更新實際參數值
          }
          if (!_backdata["coordinate"]) {
            state.coordinate['x'] = state.coordinateEnum['XDefault'].toString()
            state.coordinate['y'] = state.coordinateEnum['YDefault'].toString()
          } else {
            state.coordinate['x'] = _backdata.coordinate['x']
            state.coordinate['y'] = _backdata.coordinate['y']
          }
          store.commit('backToCalibration', false);
        } else if (_target == undefined) {
          state.brightness_max_start = 0;
          state.brightness_max = 0; // 同步更新實際參數值
          state.brightness_min_start = 0;
          state.brightness_min = 0; // 同步更新實際參數值
          state.temperature_start = 0;
          state.temperature = 0; // 同步更新實際參數值
          state.gamma_start = 0;
          state.gamma = 0; // 同步更新實際參數值
          state.coordinate['x'] = state.coordinateEnum['XDefault'].toString()
          state.coordinate['y'] = state.coordinateEnum['YDefault'].toString()
        } else {
          if (!_target["eotf"] || _target["eotf"] != state.EOTF.text) {
            // state.target = state.target_op[0];
            state.brightness_max_start = 0;
            state.brightness_max = 0; // 同步更新實際參數值
            state.brightness_min_start = 0;
            state.brightness_min = 0; // 同步更新實際參數值
            state.temperature_start = 0;
            state.temperature = 0; // 同步更新實際參數值
            state.gamma_start = 0;
            state.gamma = 0; // 同步更新實際參數值
            state.coordinate['x'] = state.coordinateEnum['XDefault'].toString()
            state.coordinate['y'] = state.coordinateEnum['YDefault'].toString()
          }
        }
        setLineBar();
      }
    )


    watch( //state.whitePointSelect disable
      () => state.whitePointSelect, (n) => {
        console.log('watch whitePointSelect', n)
        if (n && (n === 'colorTemperature' || n === 'coordinate' || n === 'standard')) {
          if (n === 'colorTemperature') {
            state.whitePointDisable = 2; // 只有 colorTemperature 可用
            console.log('whitePointDisable set to 2 (colorTemperature)')
          } else if (n === 'coordinate') {
            state.whitePointDisable = 1; // 只有 coordinate 可用
            console.log('whitePointDisable set to 1 (coordinate)')
          } else if (n === 'standard') {
            state.whitePointDisable = 0; // 只有 standard 可用，其他都 disable
            console.log('whitePointDisable set to 0 (standard)')
          }
        }
      }
    )



    //清空所有設定
    const resetCalibration = () => {
      console.log('resetCalibration')
      state.disable_all = true;
      state.selectedVal = USERMODE[1];
      state.target = {
        text: 'Target',
        val: 'default',
        isI18n: undefined,
      }
      state.gamut = { text: 'sRGB', val: 0 };
      state.dicomGamut = { text: '', val: 0 };
      state.EOTF = {
        text: 'EOTF',
        val: 'default',
      }
      state.whitePointSelect = 'colorTemperature';
      state.brightness_max_fix_right = 25;
      state.brightness_max_data = [300, 400, 500, 600, 700, 800, 900];
      state.brightness_max = 300;
      state.brightness_max_start = 300;
      state.brightness_max_default = 0;
      state.brightness_max_max = true;
      state.brightness_max_min = false;
      state.brightness_max_step = 10;
      state.brightness_min_fix_right = 25;
      state.brightness_min_data = [300, 400, 500, 600, 700, 800, 900];
      state.brightness_min = 300;
      state.brightness_min_start = 300;
      state.brightness_min_default = 0;
      state.brightness_min_dot = true;
      state.brightness_min_max = false;
      state.brightness_min_min = true;
      state.temperature_data = [40, 50, 60, 70, 80, 90];
      state.temperature = 40;
      state.temperature_max = false;
      state.temperature_min = false;
      state.temperature_lock = false;
      state.temperature_start = 40;
      state.temperature_default = 0;
      state.gamma_fix_right = 0;
      state.gamma_data = [];
      state.gamma_data_default = [1.8, 1.9, 2.0, 2.1, 2.2, 2.3, 2.4, 2.5, 2.6, 2.8];
      state.gamma = 0;
      state.gamma_start = 0.8;
      state.gamma_default = 0;
      state.gamma_dot = true;
      coordinateInit()
    }


    //點擊 group or device radio時，如果有選東西的話要跳popup提醒
    const onClickR = () => {
      if (state.dataToMulti.length) {
        const modalConfig = {
          type: POPUP.CLEARDEVICEANDGROUP,
          data: {
          },
          isShow: true,
        }
        store.commit('setIsShowModal', modalConfig)
      }
    }



    watch( //state.scaleType
      () => state.scaleType, () => {
      }
    )

    watch(
      () => state.coordinate, (n) => {
        // console.log('NNNNN',n)
        if (state.isTargetSwitching) return; // 如果正在切換 target，不執行後續邏輯
        coordinate_change(n)
      },
      { deep: true }
    )


    watch( //state.target
      () => state.target, () => {
        state.isTargetSwitching = true; // 標記開始切換 target
        var _target = state.target_op[state.target_op.map(x => x.text).indexOf(state.target.text)];
        if (_target == undefined) {
          if (state.target.text === "Customized") {
            console.log('target watch: Customized 模式，跳過參數同步');
            state.isTargetSwitching = false;
            return
          } else {
            console.log('target watch: _target 未定義，結束切換');
            state.isTargetSwitching = false;
            return
          }
        }
        console.log('target watch: 找到 target', _target);
        // console.log('11',coordinate)
        //0531新需求 target為dicom時，gamut要可以選，選項內容為SDR
        if (state.target['val'] == '5') { //DICOM
          state.showGamutSelect = true;
          if (state.dicomSelect_op && state.dicomSelect_op.length > 0) {
            state.dicomGamut = state.dicomSelect_op[0]
            state.gamut = { text: state.dicomGamut.text, val: state.dicomGamut.val };
          }
          // state.gamut = 
        } else {
          state.showGamutSelect = false;
          // 根據 target 的 gamut 找到對應的 gamut_op 選項
          const gamutOption = state.gamut_op.find(option => option.text === _target["gamut"]);
          if (gamutOption) {
            state.gamut = gamutOption;
          } else {
            state.gamut = { text: _target["gamut"], val: 0 };
          }
        }

        // 將目標中的自訂色域資料映射到 Customized Gamut 的輸入框
        if (_target["gamut_custom"]) {
          const gc = _target["gamut_custom"] as any;
          // 切換到 customized 模式並帶入座標（若存在）
          state.gamutType = 'customized';
          if (gc.red && gc.red.x != null && gc.red.y != null) {
            state.customGamut.red.x = String(gc.red.x);
            state.customGamut.red.y = String(gc.red.y);
          }
          if (gc.green && gc.green.x != null && gc.green.y != null) {
            state.customGamut.green.x = String(gc.green.x);
            state.customGamut.green.y = String(gc.green.y);
          }
          if (gc.blue && gc.blue.x != null && gc.blue.y != null) {
            state.customGamut.blue.x = String(gc.blue.x);
            state.customGamut.blue.y = String(gc.blue.y);
          }
        } else {
          // 無自訂色域時回到 standard 模式（不覆蓋既有自訂值）
          state.gamutType = 'standard';
        }

        if (state.target['val'] == '3') { //DCI-P3  target 要改預設用 x,y座標
          state.whitePointSelect = 'coordinate';
        } else {
          state.whitePointSelect = 'colorTemperature';
        }

        var _eotf;
        if (_target["eotf"]) {
          for (var a = 0; a < state.EOTF_op_default.length; a++) {
            if (state.EOTF_op_default[a]["sub"]) {
              for (var b = 0; b < state.EOTF_op_default[a]["sub"].length; b++) {
                if (_target["eotf"] == state.EOTF_op_default[a]["sub"][b].text) {
                  state.EOTF = state.EOTF_op_default[a]["sub"][b];
                  _eotf = state.EOTF_op_default[a]["sub"][b];
                }
              }
            }
            if (state.EOTF_op_default[a].text == _target["color_range"]) {
              state.EOTF_op = state.EOTF_op_default[a]["sub"];
            }
          }
        }
        if (_target["brightness"]) {
          state.brightness_max_start = _target["brightness"]
          state.brightness_max_default = _target["brightness"]
          state.brightness_max = _target["brightness"] // 同步更新 brightness_max 值
        } else {
          state.brightness_max_start = 0;
          state.brightness_max = 0; // 同步更新 brightness_max 值
        }
        if (_target["brightness_min"]) {
          state.brightness_min_start = _target["brightness_min"]
          state.brightness_min_default = _target["brightness_min"]
          state.brightness_min = _target["brightness_min"] // 同步更新 brightness_min 值
        } else {
          state.brightness_min_start = -1;
          state.brightness_min = -1; // 同步更新 brightness_min 值
        }
        if (_target["color_temperature"]) {
          state.temperature_start = _target["color_temperature"] / 100
          state.temperature_default = _target["color_temperature"] / 100
          state.temperature = _target["color_temperature"] / 100 // 同步更新 temperature 值
        } else {
          state.temperature_start = 0;
          state.temperature = 0; // 同步更新 temperature 值
        }
        // console.log(_target)
        if (_target["gamma"]) {
          state.gamma_start = _target["gamma"]
          state.gamma_default = _target["gamma"]
          // 先更新 _start 和 _default，最後再更新實際值，避免觸發 change 函數
          state.gamma = _target["gamma"] // 同步更新 gamma 值
        } else {
          state.gamma_start = 0;
          state.gamma_default = 0;
          state.gamma = 0; // 同步更新 gamma 值
        }

        //@@
        if (_target["coordinate"]) {
          state.coordinate['x'] = state.coordinateEnum['XDefault'].toString()
          state.coordinate['y'] = state.coordinateEnum['YDefault'].toString()
        } else {
          state.coordinate['x'] = '0'
          state.coordinate['y'] = '0'
        }

        if (_eotf == state.EOTF) {
          setLineBar();
        } else if (_eotf) {
          state.EOTF = _eotf;
        }
        // 延遲設定 isTargetSwitching = false，確保所有異步的 onChange 事件都在 isTargetSwitching = true 期間完成
        setTimeout(() => {
          state.isTargetSwitching = false; // 標記結束切換 target
          console.log('target watch: isTargetSwitching = false');
        }, 50);
      },
    )

    const brand = computed(() => store.state.brand);

    // 過濾掉 Customized 選項的 gamut_op
    const filteredGamutOp = computed(() => {
      return state.gamut_op.filter(option => option.val !== 7);
    });

    return {
      state,
      iconSrc,
      safeWhitePointSelect,
      onClick,
      IsChecked,
      showModal,
      chooseItem,
      brightness_max_change,
      brightness_min_change,
      temperature_change,
      gamma_change,
      checkAppointment,
      t,
      popup_table_title,
      gamutOnChange,
      gamutTypeOnChange,
      colorStandardOnChange,
      whitePointSelectOnChange,
      getCustomGamutData,
      formatCoordinate,
      handleCoordinateBlur,
      handleCoordinateInput,
      orgDicomOP,
      coordinateInit,
      coordinate_change,
      onClickR,
      getAPITablesDataGroup,
      getAPITablesData,
      popup_table_title_group,
      resetCalibration,
      USERMODE,
      brand,
      filteredGamutOp
    }
  }
}


